import { routeRefType } from './types.esm.js';

class RouteRefImpl {
  constructor(id, params) {
    this.id = id;
    this.params = params;
  }
  [routeRefType] = "absolute";
  get title() {
    return this.id;
  }
  toString() {
    return `routeRef{type=absolute,id=${this.id}}`;
  }
}
function createRouteRef(config) {
  return new RouteRefImpl(
    config.id,
    config.params ?? []
  );
}

export { RouteRefImpl, createRouteRef };
//# sourceMappingURL=RouteRef.esm.js.map
